import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { FilterFieldOption } from 'components/common/form';
import { ApiState } from 'models';
import { getStatesWithCountryCode, StatesResponse } from 'services';

export type State = ApiState<FilterFieldOption[], SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchStatesWithCountryCode = createAsyncThunk(
  'get/statesWithCountryCode',
  async (country: string) => await getStatesWithCountryCode(country)
);

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const statesWithCountryCodeSlice = createSlice({
  name: 'statesWithCountryCode',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchStatesWithCountryCode.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchStatesWithCountryCode.fulfilled, (state, action: PayloadAction<StatesResponse>) => {
      state.isLoading = false;
      state.data = action.payload.map(({ StateCode, StateName }) => ({ id: StateCode, label: StateName }));
      state.hasLoaded = true;
    });

    builder.addCase(fetchStatesWithCountryCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { statesWithCountryCode: State }): State => state.statesWithCountryCode;

export const statesWithCountryCode_ = createSelector(stateSelector_, (state) => state.data);

export const statesWithCountryCodeIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const statesWithCountryCodeHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export default statesWithCountryCodeSlice.reducer;
